import { AudioManager } from "../../AudioManager";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Utils";
import { BoardManager } from "./BoardManager";

export class GameOverLayer extends Phaser.GameObjects.Container {

    public static currentInstance: GameOverLayer;

    public rewardedAddButtonContainer: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        GameOverLayer.currentInstance = this;

        const darkLayer = new Phaser.GameObjects.Graphics(this.scene);
        darkLayer.fillStyle(0x153149, .5);
        darkLayer.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(darkLayer);

        const outOfMoves = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT * .4, "texture_atlas_3", "text_no_moves");
        outOfMoves.setScale(0);
        outOfMoves.alpha = 0;
        this.add(outOfMoves);

        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500
        });

        this.scene.tweens.add({
            targets: outOfMoves,
            scaleX: 1,
            scaleY: GameVars.scaleY,
            alpha: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 500,
            delay: 500
        });

        const restartButtonContainer = new Phaser.GameObjects.Container(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT * .55);
        restartButtonContainer.scaleY = GameVars.scaleY;
        restartButtonContainer.alpha = 0;
        this.add(restartButtonContainer);

        const restartButton = new Button(this.scene, 0, 50, "texture_atlas_3", "btn_base_off", "btn_base_on");
        restartButton.onDown(this.onDownReplay, this);
        restartButtonContainer.add(restartButton);

        const restartLabel = new Phaser.GameObjects.Image(this.scene, 0, restartButton.y, "texture_atlas_3", "text_replay");
        restartButtonContainer.add(restartLabel);

        if (GameConstants.SUPPORTS_REWARDED_ADS && GameVars.rewardedAdAvailable && !GameVars.templokEngine.boosterPurchased) {

            this.rewardedAddButtonContainer = new Phaser.GameObjects.Container(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT * .7);
            this.rewardedAddButtonContainer.scaleY = GameVars.scaleY;
            this.rewardedAddButtonContainer.alpha = 0;
            this.add( this.rewardedAddButtonContainer);
    
            const rewardedAddButton = new Button(this.scene, 0, 60, "texture_atlas_3", "btn_base_off", "btn_base_on");
            rewardedAddButton.onDown(this.onDownRewardedAd, this);
            this.rewardedAddButtonContainer.add(rewardedAddButton);

            const videoIcon = new Phaser.GameObjects.Image(this.scene, -68, rewardedAddButton.y - 2, "texture_atlas_3", "icon_ad");
            this.rewardedAddButtonContainer.add(videoIcon);
    
            const rewardedAddLabel = new Phaser.GameObjects.Text(this.scene, 30, rewardedAddButton.y, "WATCH AD", {fontFamily: "Futura-Medium", fontSize: "24px", color: "#663b1d"});
            rewardedAddLabel.setOrigin(.5);
            this.rewardedAddButtonContainer.add(rewardedAddLabel);

            const boosterDescription = new Phaser.GameObjects.Text(this.scene, 0, rewardedAddButton.y - 60, "Get +1 Re-Roll", {fontFamily: "Futura-Medium", fontSize: "30px", color: "#FFFFFF"});
            boosterDescription.setShadow(1.5, 1.5, "#000000", 5);
            boosterDescription.setOrigin(.5);
            this.rewardedAddButtonContainer.add(boosterDescription);

            this.scene.tweens.add({
                targets:  this.rewardedAddButtonContainer,
                alpha: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 500,
                delay: 2000
            });
        }

        this.scene.tweens.add({
            targets: restartButtonContainer,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500,
            delay: 1500
        });
        
        this.scene.time.delayedCall(750, function(): void {
            AudioManager.playSound("gameover");
        }, [], this);
    }

    private onDownReplay(): void {

        BoardManager.currentInstance.onRestart();
    }

    private onDownRewardedAd(): void {

        BoardManager.currentInstance.onBoosterPurchased();
    }
}
